export class Settings {
    private static beUrl: string = process.env.REACT_APP_BACKEND_BASE_URL as string;

    public static backEndBaseUrl(): string {
        return Settings.beUrl as string;
    }
}